import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M26.25 12.5H3.75M20 2.5v5m-10-5v5m3.125 10L15 16.25v6.25m-1.5625 0h3.125m-6.8125 5h10.5c2.1002 0 3.1503 0 3.9525-.4087a3.7508 3.7508 0 0 0 1.6388-1.6388c.4087-.8022.4087-1.8523.4087-3.9525V11c0-2.1002 0-3.1503-.4087-3.9525a3.7504 3.7504 0 0 0-1.6388-1.6388C23.4003 5 22.3502 5 20.25 5H9.75c-2.1002 0-3.1503 0-3.9525.4087a3.75 3.75 0 0 0-1.6388 1.6388C3.75 7.8497 3.75 8.8998 3.75 11v10.5c0 2.1002 0 3.1503.4087 3.9525a3.7504 3.7504 0 0 0 1.6388 1.6388C6.5997 27.5 7.6498 27.5 9.75 27.5Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }